import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { loginThunk } from "../../store/auth/thunkMiddlewares";
import { useAppDispatch } from "../../store/hooks";

const CallBackSignPage = () => {
  let { search } = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(search);
    const authorizationCode = query.get("code");
    dispatch(loginThunk(authorizationCode!, navigate));
  }, []);
  return <div></div>;
};

export default CallBackSignPage;
